import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_DISABLE_GEOLOCATION_GUEST_SIGN_FORM = createFcmConfig('disable_geolocation_guest_sign_form', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
